import { Component, Vue } from "vue-property-decorator";

import { UserModel } from "@/models";

@Component<AdminUserAddController>({
  components: {}
})
export default class AdminUserAddController extends Vue {
  private form: object = {
    id: 0,
    account: "",
    password: "",
    name: "",
    role: ""
  };

  private resetForm() {
    this.$data.isEdit = false;

    this.$data.form.id = 0;
    this.$data.form.account = "";
    this.$data.form.password = "";
    this.$data.form.name = "";
    this.$data.form.role = "";
  }

  private async submitForm() {
    const postData = JSON.parse(JSON.stringify(this.$data.form));

    const errNo = await UserModel.add(postData);
    if (errNo === 1) {
      window.location.href = "/admin/user";
    }
  }
}
